import LOADER from "./loader.json";
import LOADER_GREEN from "./loader-green.json";

const animations = {
  LOADER,
  LOADER_GREEN,
};

export { animations };
